@if (showAsIconOnly()) {
  <button
    ds-button
    id="ai-chat-button"
    class="flex-row"
    data-test-id="ai-chat-button"
    [attr.aria-label]="'ai_chat' | translate"
    [variant]="variant()"
    [intent]="DsButtonIntent.ai"
    [ds-tooltip]="'ai_chat' | translate"
    [tooltipPlacement]="DsTooltipPosition.bottom"
    [isIconOnly]="true"
    (click)="toggleAiChat()"
  ></button>
} @else {
  <button
    ds-button
    class="text-nowrap"
    id="ai-chat-button"
    data-test-id="ai-chat-button"
    [attr.aria-label]="'ai_chat' | translate"
    [variant]="variant()"
    [intent]="DsButtonIntent.ai"
    (click)="toggleAiChat()"
  >
    <span>{{ 'ai_chat' | translate }}</span>
  </button>
}
